/**
 * DebugPanelSection — reusable section wrapper for the Parallel Calculation
 * Debug Panel (Day 47, Decision 16). Provides a header bar + content slot
 * with consistent spacing and divider styling.
 */
import type { JSX, ReactNode } from 'react';

interface DebugPanelSectionProps {
  /** Stable identifier — drives `data-testid="debug-section-{id}"` so
   *  arbi-test.cjs can target each section deterministically. */
  id: string;
  title: string;
  /** Optional small footer line under the title (e.g. "Weights: V=0.30 …"). */
  subtitle?: string | null;
  children: ReactNode;
}

export default function DebugPanelSection({
  id,
  title,
  subtitle,
  children,
}: DebugPanelSectionProps): JSX.Element {
  return (
    <section data-testid={`debug-section-${id}`} className="border-b border-border-subtle py-3">
      <div className="px-4 pb-2">
        <h3 className="text-2xs uppercase tracking-wider text-ink-muted font-semibold">{title}</h3>
        {subtitle && <p className="text-2xs text-ink-muted mt-0.5">{subtitle}</p>}
      </div>
      <div className="px-4">{children}</div>
    </section>
  );
}
